import { forwardRef, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import StorefrontTheme from "@/components/StorefrontTheme";
import StorefrontErrorBoundary from "@/components/StorefrontErrorBoundary";
import { QuickBuyProvider } from "@/contexts/QuickBuyContext";

/**
 * Wraps all storefront (non-admin) pages so that the active theme's
 * CSS variables apply globally — including --background, --foreground, etc.
 * CartProvider and LanguageProvider are now at the App level.
 */
const StorefrontWrapper = forwardRef<HTMLDivElement, { children: ReactNode }>(({ children }, _ref) => {
  const location = useLocation();

  return (
    <StorefrontErrorBoundary resetKey={location.pathname}>
      <StorefrontTheme>
        <QuickBuyProvider>
          {children}
        </QuickBuyProvider>
      </StorefrontTheme>
    </StorefrontErrorBoundary>
  );
});

StorefrontWrapper.displayName = "StorefrontWrapper";

export default StorefrontWrapper;
